// RIBBON
// ======

const CLASS_ACTIVE = 'is-active';
const DATA_RIBBON = 'data-ribbon';
const DEFAULT_OPTIONS = {
  delay: 5000,
  navigation: '.ribbon-cp__nav',
  nextButton: '.ribbon-cp__btn--next',
  previousButton: '.ribbon-cp__btn--prev',
};

class Ribbon {
  constructor(element, options) {
    this.element = element;
    this.options = { ...DEFAULT_OPTIONS, ...options };
    this.setOption('delay');
    this.items = this.element.querySelectorAll(`[${DATA_RIBBON}-item]`);
    console.log('RIBBON', this.options, this.items, this.startItemIndex);
    // Init navigation
    this.btnNext = element.querySelector(this.options.nextButton);
    if (this.btnNext) this.btnNext.addEventListener('click', () => { this.activate(this.activeItemIndex + 1, 'slide-in-left', ''); });
    this.btnPrev = element.querySelector(this.options.previousButton);
    if (this.btnPrev) this.btnPrev.addEventListener('click', () => { this.activate(this.activeItemIndex - 1, 'slide-in-right', ''); });
    this.navs = [];
    this.navElement = element.querySelector(this.options.navigation);
    if (this.navElement) {
      for (let i = 0; i < this.items.length; i += 1) {
        const navItem = document.createElement('span');
        navItem.setAttribute('class', 'ribbon-cp__nav-item');
        navItem.addEventListener('click', () => { this.activate(i, 'slide-in-left', ''); });
        this.navs.push(navItem);
        this.navElement.append(navItem);
      }
    }
  }

  activate(index = 0, show = 'slide-in-left delay', hide = 'slide-out-left') {
    let i = index;
    if (i >= this.items.length) {
      i = 0;
    } else if (index < 0) {
      i = this.items.length - 1;
    }
    if (i !== this.activeItemIndex) {
      clearTimeout(this.timeoutId);
      if (this.activeItemIndex !== undefined) {
        this.setItemClass(hide);
        if (this.navs.length > 0) this.navs[this.activeItemIndex].classList.remove(CLASS_ACTIVE);
      }
      this.activeItemIndex = i;
      this.setItemClass(show);
      if (this.navs.length > 0) this.navs[i].classList.add(CLASS_ACTIVE);
      this.timeoutId = setTimeout(() => { this.activate(i + 1); }, this.options.delay);
    }
  }

  setItemClass(name) {
    this.items[this.activeItemIndex].className = `ribbon__item ${name}`;
  }

  setOption(name) {
    if (name in this.options) {
      const value = this.element.getAttribute(`${DATA_RIBBON}-${name}`);
      if (value !== null) this.options[name] = value;
    }
  }

  start(index = 0) {
    this.activate(index, 'slide-in-left');
  }

  step(value) {
    this.activate(this.activeItemIndex + value);
  }
}

export default Ribbon;
